import { get, put, post, del, download } from '../../api';

export const getVersoes = (page = 1) => {
  return get(`/api/conectores/versoes?page=${page}`);
};

export const getVersao = (nrBuild) => {
  return get(`/api/conectores/versao/${nrBuild}`);
};

export const getVersaoConectores = (nrBuild) => {
  return get(`/api/conectores/versao/${nrBuild}/conectores`);
};

export const putVersao = (data) => {
  return put('/api/conectores/versao', data);
};

export const postVersao = (data) => {
  return post('/api/conectores/versao', data);
};

export const deleteVersao = (nrBuild) => {
  return del(`/api/conectores/versao/${nrBuild}`);
};

export const downloadVersao = (nrBuild, jobConector) => {
  const url = `https://gitlab.com/api/v4/projects/teammove%2Fconector/jobs/${jobConector}/artifacts`;
  return download(url, `conector${nrBuild}.zip`, { 'Private-Token': 'r5_yS9GVtATEGT_t5QNK' });
};
